import type { SpecialGameRule } from "../types/enum/SpecialGameRule"

export function hasSpecialGameRule(
  specialGameRule: SpecialGameRule | null | undefined,
  specialGameRule2: SpecialGameRule | null | undefined,
  target: SpecialGameRule
) {
  return specialGameRule === target || specialGameRule2 === target
}

export function hasSpecialGameRuleInState(
  state:
    | {
        specialGameRule?: SpecialGameRule | null
        specialGameRule2?: SpecialGameRule | null
      }
    | null
    | undefined,
  target: SpecialGameRule
) {
  return hasSpecialGameRule(
    state?.specialGameRule,
    state?.specialGameRule2,
    target
  )
}
